<template>
  <div class="quick-menu">
    <Popover
      placement="bottom"
      @show="onHistoryShow"
    >
      <template #reference>
        <div
          @mouseenter="isHover.history = true"
          @mouseleave="isHover.history = false"
          class="quick-menu-item"
        >
          <Icon
            class="icon"
            :name="isHover.history ? 'time-history-full' : 'time-history-l'"
          />
        </div>
      </template>
      <History />
    </Popover>

    <div
      @mouseenter="isHover.like = true"
      @mouseleave="isHover.like = false"
      class="quick-menu-item"
      @click="toFavoritePage"
    >
      <img
        v-if="isHover.like"
        class="icon"
        src="@/assets/images/favorite-full.svg"
        alt=""
      >
      <img
        v-else
        class="icon"
        src="@/assets/images/favorite-outline.svg"
        alt=""
      >
    </div>
    <div
      @click="toCartPage"
      @mouseenter="isHover.cart = true"
      @mouseleave="isHover.cart = false"
      class="cart-wrapper"
    >
      <div class="icon">
        <template v-if="isHover.cart">
          <img
            src="@/assets/header/cart-hover.svg"
            alt=""
          >
        </template>
        <template v-else>
          <img
            v-if="cartStore.cartCount > 0"
            src="@/assets/header/cart-with-sku.svg"
            alt=""
          >
          <img
            v-else
            src="@/assets/header/cart-empty.svg"
            alt=""
          >
        </template>
      </div>
      <div class="cart-content">
        <div class="cart-count">
          {{ cartStore.cartCount > 99 ? '99+' : cartStore.cartCount }}
        </div>
        <div class="cart-text">
          Cart
        </div>
      </div>
    </div>
    <div
      @click="toOrderPage"
      @mouseenter="isHover.order = true"
      @mouseleave="isHover.order = false"
      class="quick-menu-item"
    >
      <img
        v-if="isHover.order"
        class="icon"
        src="@/assets/header/order-l.svg"
        alt=""
      >
      <img
        v-else
        class="icon"
        src="@/assets/header/order-hover.svg"
        alt=""
      >
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { buriedPointUtil } from '@/utils/utils'
import Icon from '@/components/Icon/Icon.vue'
import Popover from '@/components/Popover/index.vue'
import { useCartStore } from '@/pinia/cart'
import History from '../History.vue'

const router = useRouter()

const cartStore = useCartStore()

const isHover = ref({
  history: false,
  like: false,
  cart: false,
  order: false
})

const onHistoryShow = () => {
  buriedPointUtil({ eventId: 'PRV101' })
}

const toFavoritePage = () => {
  router.push({ name: 'favorites' })
}

const toCartPage = () => {
  buriedPointUtil({ eventId: 'PC201' })
  const { href } = router.resolve({
    path: '/carts'
  })
  window.open(href, '_blank')
}

const toOrderPage = () => {
  router.push('/orders')
}

</script>

<style lang='less' scoped>
.quick-menu {
  display: flex;
  gap: 8px;
  width: 220px;
  height: 40px;
  .quick-menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 100%;
    cursor: pointer;
    .icon {
      font-size: 32px;
      color: white;
    }
  }
  .cart-wrapper {
    display: flex;
    gap: 4px;
    width: 76px;
    cursor: pointer;
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
    }
    .cart-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
      width: 28px;
      .cart-count {
        padding: 0 6px;
        height: 14px;
        border-radius: 8px;
        background-color: #FFD100;
        outline: 1.5px solid #D25123;
        color: #232323;
        font-size: 10px;
        font-family: mon-600;
        text-align: center;
        line-height: 14px;
        margin-top: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .cart-text {
        color: white;
        font-size: 12px;
        font-family: mon-600;
      }
    }
  }
}
</style>
